jQuery(document).ready(function ($) {
    var $slide = $('.section-home-slide .swiper-container');

    if (!$slide.length) return

    var mySwiper = new Swiper('.section-home-slide .swiper-container', {
        autoplay: {
            delay: 7000,
            // pauseOnMouseEnter: true
            disableOnInteraction: false
        },
        slidesPerView: 1,
        speed: 550,
        navigation: {
            nextEl: '.slide-navigation.next',
            prevEl: '.slide-navigation.prev',
        },
        pagination: {
            el: '.slide-pagination',
            type: 'bullets',
            bulletClass: 'bullet',
            bulletActiveClass: 'bullet-active'
        },
    });
});